<app-legals-footer-block [links]="links"></app-legals-footer-block>
